import {
  AssignableExpressionInput,
  Datatype,
  IWidgetComponentProps,
  useTreeReferencesContext,
} from '@framework/engine';
import { FormItem } from '@framework/form';
import React from 'react';
import { ISiapDataWidget } from './ISiapDataWidget';

const TFromItem = FormItem as typeof FormItem<ISiapDataWidget>;

export interface ISiapDataConfigComponentProps
  extends IWidgetComponentProps<ISiapDataWidget> {}

export function SiapDataConfigComponent(props: ISiapDataConfigComponentProps) {
  const { references } = useTreeReferencesContext();

  return (
    <>
      <TFromItem name="aooField" label="Codice AOO">
        <AssignableExpressionInput
          size="large"
          block
          references={references}
          name="aooField"
          field={{ type: Datatype.String }}
        />
      </TFromItem>
    </>
  );
}
